type DropzoneContainerProps = {
  children: React.ReactNode;
  className?: string;
  onDropFiles: (files: FileList | null) => void;
  onClick: () => void;
};

export const DropzoneContainer = ({
  children,
  className,
  onDropFiles,
  onClick,
}: DropzoneContainerProps) => {
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    onDropFiles(e.dataTransfer.files);
  };

  return (
    <div
      className={className}
      onClick={onClick}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {children}
    </div>
  );
};
